import { t } from "i18next";
import * as z from "zod";

import { CUSTOMER_SEGMENTS } from "@/features/shared/api/enums";

/**
 * Schéma du formulaire de lancement d'une paie (lot de versements
 * `PAYROLL_CREDIT` via `POST /Transactions/initiate`, guide §5.3) —
 * montants saisis en unité MAJEURE (convertis en `amountMinor` au submit
 * via `majorToMinor`). Un lot = portefeuille source de l'entreprise +
 * N bénéficiaires (portefeuille destinataire + montant).
 *
 * Factory (règle projet) : créé via `createPayrollRunSchema()` et mémoïsé
 * au niveau composant sur la langue courante — jamais d'instance exportée.
 */
export const createPayrollRunSchema = () =>
  z.object({
    productCode: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    sourceWalletId: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") })
      .uuid({ message: t("invalidFieldError") }),
    customerSegment: z.enum(CUSTOMER_SEGMENTS, {
      errorMap: () => ({ message: t("requiredFieldError") }),
    }),
    partyId: z
      .string()
      .trim()
      .uuid({ message: t("invalidFieldError") })
      .or(z.literal(""))
      .optional(),
    customerReference: z.string().trim().or(z.literal("")).optional(),
    beneficiaries: z
      .array(
        z.object({
          destinationWalletId: z
            .string()
            .trim()
            .min(1, { message: t("requiredFieldError") })
            .uuid({ message: t("invalidFieldError") }),
          amount: z
            .number({ invalid_type_error: t("invalidFieldError") })
            .positive({ message: t("invalidFieldError") }),
          label: z.string().trim().or(z.literal("")).optional(),
        })
      )
      .min(1, { message: t("requiredFieldError") }),
  });

export type PayrollRunFormValues = z.infer<
  ReturnType<typeof createPayrollRunSchema>
>;
export type PayrollBeneficiaryFormValues =
  PayrollRunFormValues["beneficiaries"][number];
